module.exports = __webpack_public_path__ + "~@/assets/img/black-135-35.631e1ae4.svg";